// General
import "./lifestyle-filter-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateLifestyleFilterDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
// Components
import LifestyleFilter from "../../../elements/filters/lifestyle-filter/lifestyle-filter";

const LifestyleFilterDialog = () => {
  // Redux variables
  const lifestyleFilterDialog = useSelector(
    (state) => state.dialog.lifestyleFilterDialog
  );
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!lifestyleFilterDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-LifestyleFilter-Dialog",
      },
    });
  }, [lifestyleFilterDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateLifestyleFilterDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={lifestyleFilterDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <LifestyleFilter />
    </Dialog>
  );
};

export default LifestyleFilterDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
